<script>
import { Storage } from '../../../utils/services/storage-service';
import { EVENTS } from "../../../utils/constants/bus-events-constants";
import { MOTION_EVENTS_PERMISSIONS } from "../../../utils/constants/app-constants";

export default {
    name: 'MotionStack',
    render(){ return null },
    data () {
        return {
            gyro: null,
            compass: null,
            pedometer: null
        }
    },
    methods:{
        injectScripts(){
            if (document.MotionStack) return;

            const s = document.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.onload = this.onLoad;
            s.src = '/motion-stack/motionstack-v2.0.3.min.js';
            const x = document.getElementsByTagName('head')[0];
            x.appendChild(s);
        },
        onLoad(){
            this.requestPermissionsIfNeeded();
            this.$emit('ready');
            this.initEventsListeners();
        },
        mounted() {
            this.requestPermissionsIfNeeded();
        },
        async requestPermissionsIfNeeded(){
            const isMotionEventSupport = typeof(DeviceMotionEvent) !== "undefined" && typeof(DeviceMotionEvent.requestPermission) === "function";
            const isOrientationEventSupport = typeof(DeviceOrientationEvent) !== "undefined" && typeof(DeviceOrientationEvent.requestPermission) === "function";
            
            if (isMotionEventSupport) {
                try {
                    const response = await DeviceMotionEvent.requestPermission();

                    Storage.local.set(MOTION_EVENTS_PERMISSIONS, response);

                    if (response === 'denied') {
                        this.$bus.$emit(EVENTS.DISABLE_AR_VIEW);
                    }
                } catch(error) {
                    console.warn(error);
                }
            }

            if (isOrientationEventSupport) {
                try {
                    await DeviceOrientationEvent.requestPermission();
                } catch(error) {
                    console.warn(error);
                }
            } 
        },
        initEventsListeners(){
            const isIOS = !(
                navigator.userAgent.match(/(iPod|iPhone|iPad)/) &&
                navigator.userAgent.match(/AppleWebKit/)
            );

            if (this.$listeners.compass) {
                if(!MotionStack.Compass.isSupported()){
                    alert('Compass is not available');
                }
                this.compass = new MotionStack.Compass({
                    fireOnAnimationFrame: true,
                });
                this.compass.start(this.onCompass, this);
                /*if(isIOS)
                {
                    window.addEventListener("deviceorientation", this.onCompass, true);
                }
                else
                {
                    window.addEventListener("deviceorientationabsolute", this.onCompass, true);
                }*/

            }

            if (this.$listeners.gyro) {
                if(!MotionStack.Orientation.isSupported()){
                    alert('Orientation is not available');
                }
                this.gyro = new MotionStack.Orientation({
                    absolute: true,
                    fireOnAnimationFrame: true,
                });
                this.gyro.start(this.onGyro, this);
            }

            if (this.$listeners.step || this.$listeners.stepForward) {
                if(!MotionStack.Pedometer.isSupported()){
                    alert('Pedometer is not available');
                }
                this.pedometr = new MotionStack.Pedometer({
                    fireOnAnimationFrame: true,
                });
                this.pedometr.start(this.onStep, this);
            }
        },
        removeEventsListeners(){
            this.compass && this.compass.stop();
            this.pedometr && this.pedometr.stop();
            this.gyro && this.gyro.stop();
        },

        onCompass(e){
            this.$emit('compass', e.heading);
        },
        onGyro(e){
            this.$emit('gyro', {
                //compassHeading: Math.round(e.compassHeading),
                //compassError: Math.round(e.compassError),
                pitch: Math.round(e.pitch*10)/10,
                //roll: Math.round(e.roll),
                //yaw: Math.round(e.yaw),
            });
        },
        onStep(e){
            this.$emit('step', e);
            if(e.stepZ === 1){
                this.$emit('stepForward', e);
            }
        },
    },
    created () {
        if (!window.DeviceOrientationEvent || !window.DeviceMotionEvent) {
            this.$emit('error', 'ERROR: DeviceOrientation API is not supported in this browser ')
        } else {
            this.injectScripts()
        }
    }
}
</script>
